/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Intercompany_Rule_InvalidInputs */

const en_error_intercompany_rule_invalid = /** @type {(inputs: Error_Intercompany_Rule_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This rule could not price a transfer.`)
};

/**
* | output |
* | --- |
* | "This rule could not price a transfer." |
*
* @param {Error_Intercompany_Rule_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_intercompany_rule_invalid = /** @type {((inputs?: Error_Intercompany_Rule_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Intercompany_Rule_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_intercompany_rule_invalid(inputs)
});